import { render, staticRenderFns } from "./ReceptionDetails.vue?vue&type=template&id=fcd60fd0&scoped=true"
import script from "./ReceptionDetails.vue?vue&type=script&lang=js"
export * from "./ReceptionDetails.vue?vue&type=script&lang=js"
import style0 from "./ReceptionDetails.vue?vue&type=style&index=0&id=fcd60fd0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fcd60fd0",
  null
  
)

export default component.exports